import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  // Use Bearer token auth (no cookies) to avoid cross-origin credentialed CORS issues.
});

// Attach token from localStorage too (backup for cross-domain cookie issues)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("rpg_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileSrc(url) {
  // url returned from backend e.g. /api/files/<id>
  const t = localStorage.getItem("rpg_token");
  if (!url) return "";
  const sep = url.includes("?") ? "&" : "?";
  return `${BACKEND_URL}${url}${t ? `${sep}auth=${encodeURIComponent(t)}` : ""}`;
}

export default api;
